import { Checkbox, Pagination, Skeleton, Stack } from "@mui/material";
import Slider from "@mui/material/Slider";
import { Menu, MenuButton, MenuItem } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import { useEffect, useRef, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import api from "../../api/api";
import blackAngleDown from "../../assets/icons/angle-down.png";
import blackAngleUp from "../../assets/icons/angle-up.png";
import { OutlineButton } from "../../components/outline-button";
import { ProductCard } from "../../components/ProductCard";
import { environment } from "../../environments/environment";
import { IProductAdmin, IProductImages } from "../../models/admin/products";
import { IAppState } from "../../store/store";

function valuetext(value: number) {
  return `${value}°C`;
}

const sortDropdown = [
  { name: "NONE", value: null },
  { name: "BEST SELLER", value: "best_seller" },
  { name: "BEST MATCH", value: "best_match" },
  { name: "PRICE LOW", value: "price_low" },
  { name: "PRICE HIGH", value: "price_high" },
  { name: "ALPHABETICALLY (A-Z)", value: "alphabetically_a" },
  { name: "ALPHABETICALLY (Z-A)", value: "alphabetically_z" },
];

export const Shop = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const initialized = useRef(false);

  const [priceRange, setValue] = useState<number[]>([0, 250]);
  const [currentPage, setCurrentPage] = useState(1);
  const [categoriesSelected, setCategoriesSelected] = useState<string[]>([]);
  const [sort, setSort] = useState<string | null>(null);

  const [products, setProducts] = useState<IProductAdmin[] | null>(null);
  const [totalPages, setTotalPages] = useState(1);
  const [ordersData, setOrdersData] = useState<{ [key: string]: number }>({});
  const [categoriesList, setCategoriesList] = useState<
    { name: string; short_name: string }[]
  >([]);
  
  const [productImages, setProductImages] = useState<IProductImages[] | null>(null)

  // Read currency from Redux state
  const currency = useSelector((state: IAppState) => state.shared.currency);
  const hasSwitchedCurrency = useSelector(
    (state: IAppState) => state.shared.hasSwitchedCurrency
  );

  const fetchCategoriesList = async () => {
    try {
      const response = await api.get(`${environment.baseUrl}/admin/categories`);

      if (response.data.code == 200) {
        setCategoriesList(response.data.data.all_categories);
      }
    } catch (error) {
      navigate("/shop");
    }
  };

  useEffect(() => {
    fetchCategoriesList();
    const params = new URLSearchParams(location.search);
    const minprice = params.get("minprice");
    const maxprice = params.get("maxprice");
    const page = params.get("page");
    const sort = params.get("sort");

    if (minprice && maxprice) {
      setValue([parseInt(minprice), parseInt(maxprice)]);
    }
    if (page) {
      setCurrentPage(Number(page));
    }

    if (sort) {
      setSort(sort);
    }


    fetchProducts(currentPage);
  }, [currentPage, categoriesSelected, sort, currency]);

  const fetchProducts = async (page: number) => {
  const params: any = { page: currentPage };

  // if (priceRange[0]) {
  //   params.min_price = priceRange[0];
  // }
  // if (priceRange[1]) {
  //   params.max_price = priceRange[1];
  // }

  // params.currency = currency;

  // if (categoriesSelected[0]) {
  //   params.category = categoriesSelected[0].toLowerCase();
  // }
  if (sort) {
    params.sort = sort;
  }

  try {
    const response = await api.get(`${environment.baseUrl}/product/fetch/list`, {
      params: params,
    } );
  

    const productImages = response.data.data.product_images;

    const extractedImages = Object.entries(productImages)
      .filter(([_, imagesArray]) =>
        (imagesArray as { product_uuid: string; media_url: string }[]).length > 0
      )
      .map(([product_uuid, imagesArray]) => {
        const firstImage = (imagesArray as { product_uuid: string; media_url: string }[])[0];
        return {
          product_uuid: firstImage.product_uuid,
          media_url: firstImage.media_url,
        };
      });

    setProductImages(extractedImages);

    // const unsortedProducts = response.data.data?.products?.rows ?? [];
    // const sortedProducts = [...unsortedProducts].sort((a, b) => a.sort_id - b.sort_id);
    // setProducts(sortedProducts);
    setProducts(response.data.data?.products?.rows ?? []);

    setOrdersData(response.data.data?.current_orders ?? {});
    setTotalPages(response.data.data?.products.total_pages);
  } catch (error) {
    // Handle error appropriately
  }
};


  const handlePriceRangeChange = (
    event: Event,
    newValue: number | number[]
  ) => {
    setValue(newValue as number[]);

    // Update URL parameters
    const params = new URLSearchParams(location.search);
    params.set("minprice", (newValue as number[])[0].toString());
    params.set("maxprice", (newValue as number[])[1].toString());
    navigate(`?${params}`);
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page);
    const params = new URLSearchParams(location.search);
    params.set("page", page.toString());
    navigate(`?${params}`);
  };

  return (
    <Wrapper className="web_padding_y web_padding_x">
      <h2 className="web_heading text-left md:text-center">SHOP</h2>
      <div className="flex cont mt-5 md:mt-10">
        {/* <div className="filter">
          <Menu
            className="campaign_price_menu"
            menuButton={
              <MenuButton className="w-full sm:w-fit">
                <OutlineButton text="PRICE" className="w-full sm:w-fit" />
              </MenuButton>
            }
            direction="bottom"
            align="center"
            offsetY={24}
            arrow={true}
          >
            <div className="w-fit mx-auto mt-2 text-lg font-bold">
              ₵{priceRange[0]} - ₵{priceRange[1]}
            </div>
            <div className="px-3">
              <Slider
                min={1}
                max={250}
                getAriaLabel={() => "Price range filter"}
                value={priceRange}
                onChange={handlePriceRangeChange}
                onChangeCommitted={() => fetchProducts(currentPage)}
                getAriaValueText={valuetext}
              />
            </div>
            <div className="flex items-center justify-between font-bold text-xl">
              <span>₵ 0</span>
              <span>₵ 250</span>
            </div>
            <div className="mt-4 h-[2px] bg-[#d4d4d4]"></div>
            <button className="block mt-1 mx-auto w-fit outline-none underline text-[#d4d4d4] text-lg font-semibold">
              Clear
            </button>
          </Menu>
          <Menu
            className="campaign_brand_menu"
            menuButton={
              <MenuButton className="w-full sm:w-fit">
                <OutlineButton
                  text="CATEGORY"
                  className="w-full sm:w-fit justify-center"
                  icon={<img className="w-4" src={blackAngleDown} />}
                />
              </MenuButton>
            }
            direction="bottom"
            align="center"
            offsetY={24}
            arrow={true}
          >
            <div className="relative">
              <FiSearch className="absolute center_y left-4 text-2xl text-[#d4d4d4]" />
              <input
                type="text"
                className="outline-none w-full border-2 border-[#d4d4d4] border-solid rounded-[21px] pl-10 pr-4 h-[41px]"
              />
            </div>
            <div className="font-medium rounded mt-2 grid text-lg py-3 bg-white max-h-[270px] overflow-y-auto">
              {categoriesList.map((category, index) => (
                <MenuItem
                  key={index}
                  onClick={() => false}
                  className="flex items-center font-semibold !px-2 justify-between"
                >
                  <Checkbox
                    aria-label={category.name}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                    onChange={(e) => {
                      const catArr = [...categoriesSelected];
                      if (e.target.checked) {
                        catArr.push(category.short_name);
                        setCategoriesSelected(catArr);
                      } else {
                        const updatedCategories = catArr.filter(
                          (cat) => cat !== category.short_name
                        );
                        setCategoriesSelected(updatedCategories);
                      }
                    }}
                  />
                  <label
                    htmlFor="item-1"
                    className="flex-1 text-base sm:text-xl leading-5"
                  >
                    {category.name}
                  </label>
                </MenuItem>
              ))}
            </div>
            <div className="mt-4 h-[2px] bg-[#d4d4d4]"></div>
            <button className="block mt-1 mx-auto w-fit outline-none underline text-[#d4d4d4] text-lg font-semibold">
              Clear
            </button>
          </Menu>
          <OutlineButton
            text="PRODUCT"
            className="w-full sm:w-fit justify-center"
            icon={<img className="w-4" src={blackAngleDown} />}
          />
        </div> */}

        <Menu
          className="campaign_sort"
          menuButton={
            <MenuButton>
              <div className="flex items-center gap-2 group">
                <p className="font-bold flex gap-4">
                  <span className="sort">SORT BY</span>
                  <span className="font-normal group-hover:scale-[1.01] duration-700">
                    {sortDropdown.find((x) => x.value === sort)?.name}
                  </span>
                </p>
                <img
                  src={blackAngleUp}
                  className="w-4 group-hover:scale-[1.3] duration-700"
                />
              </div>
            </MenuButton>
          }
          direction="bottom"
          align="center"
          offsetY={24}
          arrow={true}
        >
          <div className="font-medium rounded grid  text-lg py-3 bg-white">
            {sortDropdown.map((item, index) => (
              <MenuItem
                className={`${sort === item.value ? "active_sort" : ""}`}
                onClick={() => {
                  setSort(item.value);
                  const params = new URLSearchParams(location.search);
                  if (item.value) {
                    params.set("sort", item.value);
                  } else {
                    params.delete("sort");
                  }
                  navigate(`?${params}`);
                }}
                key={index}
              >
                {item.name}
              </MenuItem>
            ))}
          </div>
        </Menu>
      </div>
      {products && (
        <>
          <div className="grid gap-6 sm:[grid-template-columns:repeat(auto-fill,minmax(300px,_1fr))] lg:grid-cols-3">
            {products?.map((product: IProductAdmin) => {
              const productImageUrl = productImages?.find(
                (img) => img.product_uuid === product.uuid
              )?.media_url;
              return (
                <ProductCard
                  key={product.uuid}
                  product={product}
                  productImage={
                    productImageUrl!
                  }
                />
              )
            })}
          </div>
          {products.length ? (
            <div className="mt-4 flex justify-center">
              <Pagination
                count={totalPages}
                page={currentPage}
                onChange={handlePageChange}
                variant="outlined"
                shape="rounded"
              />
            </div>
          ) : (
            // <div>No Campaigns Found</div>
            <></>
          )}
        </>
      )}{" "}
      {products?.length === 0 && (
        <>
          <div className="border border-dashed text-center border-gray-400 mt-4 mx-auto max-w-[450px] rounded-lg px-10 py-20">
            No products found
          </div>
        </>
      )}
      {!products && (
        <>
          <Stack spacing={1}>
            <Stack spacing={1} direction={"row"}>
              <Skeleton variant="rounded" width={400} height={200} />
              <Skeleton variant="rounded" width={400} height={200} />
              <Skeleton variant="rounded" width={400} height={200} />
            </Stack>
            <Stack spacing={1} direction={"row"}>
              <Skeleton variant="rounded" width={400} height={200} />
              <Skeleton variant="rounded" width={400} height={200} />
              <Skeleton variant="rounded" width={400} height={200} />
            </Stack>
          </Stack>
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.main`
  .flex.cont {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2.5rem;
    flex-wrap: wrap;
    gap: 20px;
  }
  .filter {
    display: flex;
    gap: 1.4rem;
    flex-wrap: wrap;
  }
  .sort {
    position: relative;
  }
  .sort::after {
    content: "";
    position: absolute;
    top: 10%;
    right: -0.52rem;
    height: 90%;
    background-color: black;
    width: 3px;
  }
`;